export enum ThemeModeModel {
  LIGHT = "Light",
  DARK = "Dark",
  SYSTEM = "System",
}

export enum ThemeAccentModel {
  VIOLET = "Violet",
  BLUE = "Blue",
  YELLOW = "Yellow",
  GREEN = "Green",
  RED = "Red",
  ORANGE = "Orange",
}

export type ThemeModel = {
  mode: ThemeModeModel;
  accent: ThemeAccentModel;
};
